import React, { forwardRef } from 'react'
import { useDrop, UseDropProps } from '../../utils'
import {
  SelectDropdownLinkItem,
  SelectDropdownLinkItemProps,
} from '@sketch/components'

interface DroppableLinkItemProps
  extends SelectDropdownLinkItemProps,
    UseDropProps {
  forceHighlight?: boolean
}

// TODO: Review react/display-name ESLint issues
//  see: https://github.com/sketch-hq/Cloud/issues/14818
// eslint-disable-next-line react/display-name
export const DroppableLinkItem = forwardRef(
  (props: DroppableLinkItemProps, ref) => {
    const {
      forceHighlight = false,
      onShareDropped,
      onProjectDropped,
      ...linkProps
    } = props
    const { isDraggedOver, kind, isDraggedOverItself, ...dragEvents } = useDrop(
      { onShareDropped, onProjectDropped }
    )

    return (
      <SelectDropdownLinkItem
        forceHover={isDraggedOver && !isDraggedOverItself}
        forceActive={forceHighlight}
        ref={ref}
        {...linkProps}
        {...dragEvents}
      />
    )
  }
)
